import httpService from '@/services/core/http.service';

class SensorsService {
    route = 'tiny-pumper/sensors';

    all = () => httpService.get(`${this.route}/all`);
    // Remote store, not a list: the fleet grid is paged, sorted and filtered by SQL Server.
    healthOverviewDataSource = watchListId =>
        httpService.getDxDataSource(`${this.route}/health-overview/grid${watchListId ? `?watchListId=${watchListId}` : ''}`);
    holdOn = (id, bool) => httpService.put(`${this.route}/${id}/hold-on?isHoldOn=${bool}`, null);
    status = id => httpService.get(`${this.route}/${id}/status`);
    levelcon = sensorId => httpService.get(`${this.route}/${sensorId}/levelcon`);

    healthOverviewTotals = watchListId =>
        httpService.get(`${this.route}/health-overview/totals${watchListId ? `?watchListId=${watchListId}` : ''}`);

    levelconDashboardLink = levelconId => (levelconId ? `https://one.levelcon.com/Dashboard.html?assetID=${levelconId}/` : null);
}

export default new SensorsService();
